// extracted by mini-css-extract-plugin
export default {"wrapper":"MaintenanceMode_wrapper__Ny5ug","header":"MaintenanceMode_header__vQDgo","content":"MaintenanceMode_content__0gMbS","text-1":"MaintenanceMode_text-1__GVo0b"};